/**
 * 安聆 SafeListen - 常亮监测模式模块
 * 基于 Wake Lock API，仅监测端显示；失效时提示
 */
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import { message } from 'antd';
import './KeepScreen.css';

export default function KeepScreen({ isMonitor }) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const wakeLockRef = useRef(null);
  const [tipsVisible, setTipsVisible] = useState(false);

  const releaseWakeLock = useCallback(async () => {
    if (wakeLockRef.current) {
      try {
        await wakeLockRef.current.release();
      } catch (_) {}
      wakeLockRef.current = null;
    }
    setActive(false);
  }, []);

  const requestWakeLock = useCallback(async () => {
    if (!navigator.wakeLock) {
      message.warning(
        typeof navigator.languages !== 'undefined' && navigator.languages[0]?.startsWith('zh')
          ? '当前浏览器不支持常亮模式'
          : 'Always-on mode is not supported in this browser.'
      );
      return;
    }
    try {
      const wl = await navigator.wakeLock.request('screen');
      wakeLockRef.current = wl;
      wl.addEventListener('release', () => {
        wakeLockRef.current = null;
        setActive(false);
        message.info(t('wakeLock.released'));
      });
      setActive(true);
      setTipsVisible(true);
    } catch (e) {
      message.error('Failed to enable always-on / 无法开启常亮');
    }
  }, [t]);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && active && wakeLockRef.current === null && navigator.wakeLock) {
        requestWakeLock();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [active, requestWakeLock]);

  useEffect(() => () => {
    releaseWakeLock();
  }, [releaseWakeLock]);

  if (!isMonitor) return null;

  return (
    <>
      <div className="safelisten-card keep-screen">
        <Button
          type="default"
          className={active ? 'safelisten-btn-warning' : 'safelisten-btn-secondary'}
          onClick={active ? releaseWakeLock : requestWakeLock}
        >
          {active ? t('keepScreen.disable') : t('keepScreen.enable')}
        </Button>
      </div>
      <Modal
        open={tipsVisible}
        title={t('keepScreen.tipsTitle')}
        onCancel={() => setTipsVisible(false)}
        footer={[
          <Button key="ok" type="primary" className="safelisten-btn-primary" onClick={() => setTipsVisible(false)}>
            OK
          </Button>,
        ]}
      >
        <p style={{ whiteSpace: 'pre-wrap' }}>{t('keepScreen.tipsContent')}</p>
      </Modal>
    </>
  );
}
